export default __webpack_public_path__ + "static/media/icon-no-data.8695324f.svg";